module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/headerImg.a6c92c7f.jpg";